// src/lib/salepage/useAreaShippingQuote.ts
// hook ฝั่งเซลเพจ: ถามค่าส่งรายพื้นที่จาก /api/public/shipping ตามที่อยู่ที่ลูกค้ากรอก
//
// ก่อนหน้านี้หน้า checkout คิดค่าส่งจาก "ค่าปกติ" อย่างเดียว ทั้งที่ server คิดราคา
// พื้นที่ตอนสร้างออเดอร์ → ลูกค้าเห็นตัวเลขหนึ่ง แต่ออเดอร์เป็นอีกตัวเลข. hook นี้
// ยิง quote ทุกครั้งที่กรอกครบ จังหวัด/อำเภอ/ตำบล (debounce) ให้ตัวเลขตรงกัน
//
// ผลลัพธ์:
//   fee     = ราคาพื้นที่ (FIXED) ใช้แทนค่าส่งปกติ; null = ไม่ตรงพื้นที่พิเศษ
//   ask     = พื้นที่ "ระบุค่าส่งไม่ได้" (requirement 2026-09-07) — ไม่คิดค่าส่งตอนสั่ง
//             แต่ต้องเด้ง popup ข้อความ `message` ตอนกดสั่งซื้อ
//   message = ข้อความ popup ของร้าน

'use client'

import { useEffect, useState } from 'react'

export interface AreaShippingQuote {
  fee: number | null
  ask: boolean
  message: string
}

export function useAreaShippingQuote(
  shopId: string,
  province: string,
  district: string,
  subdistrict: string,
): AreaShippingQuote | null {
  const [quote, setQuote] = useState<AreaShippingQuote | null>(null)

  useEffect(() => {
    const p = province.trim()
    const d = district.trim()
    const s = subdistrict.trim()
    if (!shopId || !p || !d || !s) {
      setQuote(null)
      return
    }
    let alive = true
    const timer = setTimeout(() => {
      const qs = new URLSearchParams({ shopId, province: p, district: d, subdistrict: s })
      fetch(`/api/public/shipping?${qs.toString()}`)
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (!alive || !data) return
          setQuote({
            fee: typeof data.areaFee === 'number' ? data.areaFee : null,
            ask: data.areaAsk === true,
            message: typeof data.areaAskMessage === 'string' ? data.areaAskMessage : '',
          })
        })
        .catch(() => {
          if (alive) setQuote(null)
        })
    }, 350)
    return () => {
      alive = false
      clearTimeout(timer)
    }
  }, [shopId, province, district, subdistrict])

  return quote
}
